import { Field, Input, InputGroup } from '@chakra-ui/react'
import { FormErrors } from 'commons/components/layout/FormErrors'
import { Label } from 'commons/components/layout/Label'
import { Section } from 'commons/components/layout/Section'
import { useFieldContext } from 'commons/config/form'
import { BgColors, TextColors } from 'commons/design-system/tokens'
import type { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

export const NameSection = () => {
	const field = useFieldContext<string>()
	const { t } = useTranslation()

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		// Block only numbers, allow everything else including letters, accents, and special characters
		const filteredValue = e.target.value.replace(/[0-9]/g, '')
		field.handleChange(filteredValue)
	}

	return (
		<Field.Root
			invalid={
				!field.state.meta.isValid || (field.state.meta.errors && field.state.meta.errors.length > 0)
			}
		>
			<Section
				_focusWithin={{ outline: `2px solid ${BgColors.OPPOSITE_Z3}` }}
				_groupInvalid={{
					outline: `2px solid ${TextColors.STATUS_ERROR}`
				}}
			>
				<Label>{t('phone_form.name_label')}</Label>
				<InputGroup>
					<Input
						fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
						fontWeight={500}
						id='name'
						name='name'
						type='text'
						autoComplete='name'
						variant='unstyled'
						py={2}
						placeholder='...'
						value={field.state.value || ''}
						onChange={handleChange}
						_focus={{ outline: 'none' }}
						_focusVisible={{ outline: 'none' }}
					/>
				</InputGroup>
				<FormErrors errors={field.state.meta.errors} />
			</Section>
		</Field.Root>
	)
}
